import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Layers, LayoutGrid, Users, Calendar, Settings, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

const navItems = [
  { path: "/", icon: LayoutGrid, label: "Status Overview" },
  { path: "/team", icon: Users, label: "Team Board" },
  { path: "/deadlines", icon: Calendar, label: "Deadlines" },
  { path: "/config", icon: Settings, label: "Configuration" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="p-4 border-b border-slate-200">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-slate-900 rounded flex items-center justify-center">
            <Layers className="w-4 h-4 text-white" />
          </div>
          <span className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>PLM v3</span>
        </div>
      </div>

      <nav className="p-3 space-y-1" data-testid="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/"}
            className={({ isActive }) => 
              `flex items-center gap-2 px-3 py-2 rounded text-sm transition-colors ${
                isActive ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100'
              }`
            }
            data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
          >
            <item.icon className="w-4 h-4" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="absolute bottom-0 left-0 right-0 p-3 border-t border-slate-200 bg-white">
        <div className="flex items-center gap-2 mb-2 px-2">
          <div className="w-6 h-6 bg-slate-200 rounded-full flex items-center justify-center text-xs font-medium">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <span className="text-sm text-slate-700 truncate">{user?.name}</span>
        </div>
        <Button 
          variant="ghost" 
          size="sm"
          className="w-full justify-start text-slate-500 h-8"
          onClick={() => { logout(); navigate("/login"); }}
          data-testid="logout-btn"
        >
          <LogOut className="w-3 h-3 mr-2" />
          Sign out
        </Button>
      </div>
    </aside>
  );
}
